module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0094.png.e3ff46a2.jpg";